import { useNavigate } from 'react-router-dom';
import { Button } from "./primitives/Button";
import { FaApple } from "react-icons/fa";
import { catchErrorAuth } from '../ErrorUtility';
//import { GoogleIcon } from './svg-rfc';
import GoogleLogoIcon from '../assets/service-icons/GoogleLogoIcon.svg';
import MicrosoftLogoIcon from '../assets/service-icons/MicrosoftLogoIcon.svg';

export default function AuthButton({children, type, loginCallback = () => {}, setLoading = () => {}, setError = () => {}, signup = false, ...rest}) {

  const navigate = useNavigate();

    async function handleAuth(e) {
        e.preventDefault();
        try {
            setLoading(true);
            const [result, errorCode, errorMessage] = await catchErrorAuth(loginCallback);
            if (errorCode) {
                setError(errorMessage);
            } else {
                navigate("/");
            }
        } finally {
            setLoading(false);
        }
    }

    return (
        <Button onClick={handleAuth} className='auth-button'style={{ marginTop: signup ? "10px" : "0" }} {...rest} >
            <div className='auth-button-container'>
                {type === "google" && <img src={GoogleLogoIcon} alt="Google Icon" className='auth-button-icon' />}
                {type === "microsoft" && <img src={MicrosoftLogoIcon} alt="Microsoft Icon" className='auth-button-icon' />}
                {type === "apple" && <FaApple className='auth-button-icon' />}
                <span className='auth-button-text'>{children}</span>
            </div>
        </Button>
    )
}
